import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { SectionLabel, WordsPullUp } from '@/components/animations';

const BEEHIIV_SUBSCRIBE = 'https://j-urbinati.beehiiv.com/subscribe';
const BEEHIIV_SIGNUP = 'https://j-urbinati.beehiiv.com/?modal=signup';

export const LettersCard = ({ active }) => {
  const [email, setEmail] = useState('');

  // Hand off to the real beehiiv signup (prefilling the email when valid) so the
  // subscription is actually created and confirmed on beehiiv.
  const handleSubscribe = (e) => {
    e.preventDefault();
    const valid = /^\S+@\S+\.\S+$/.test(email);
    const url = valid ? `${BEEHIIV_SUBSCRIBE}?email=${encodeURIComponent(email)}` : BEEHIIV_SIGNUP;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={active ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
      transition={{ duration: 1.6, ease: 'easeOut', delay: 0.2 }}
      className="glass-card-ember w-[min(560px,90vw)] p-7 sm:p-12"
      data-testid="letters-card"
    >
      <SectionLabel ember>Newsletter</SectionLabel>
      <h2 className="font-display text-3xl sm:text-4xl text-cream-warm leading-tight font-normal">
        <WordsPullUp text="Letters from J. Urbinati." active={active} />
      </h2>
      <p className="mt-3 font-serif italic text-lg sm:text-xl leading-snug text-cream-warm/75">
        A newsletter on dark fantasy writing, worldbuilding, and the making of The King Below.
      </p>
      <p className="mt-5 text-sm sm:text-base leading-relaxed text-muted-foreground">
        This is not a tech newsletter. These are dispatches from inside the creative process — the
        lore, the characters, the obsessions.
      </p>
      <form onSubmit={handleSubscribe} className="mt-7 flex flex-col sm:flex-row gap-3" data-testid="letters-form">
        <Input
          type="email"
          data-testid="letters-email-input"
          className="h-12 flex-1 rounded-full border-cream/25 bg-background/70 px-5 text-cream placeholder:text-faint focus-visible:ring-ember-soft/50"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button type="submit" variant="cream" size="pill" className="h-12" data-testid="letters-subscribe-btn">
          <Mail />
          Subscribe
        </Button>
      </form>
    </motion.div>
  );
};
